import moment from 'moment'
import { useState } from 'react'
import ReactTooltip from 'react-tooltip'

import { CheckIcon } from '../../../../components/ReusableComponents/Icons/Check'
import { CrossIcon } from '../../../../components/ReusableComponents/Icons/Cross'
import { Cell } from '../../../../components/ReusableComponents/Table/index'
import styles from './CampaignStatusCell.module.scss'

const GreenCheck = () => <CheckIcon className={styles.greenCheck} />
const GrayCross = () => <CrossIcon className={styles.grayCross} />

const CampaignStatusCell = ({ campaigns, kind, subsidiaryId }) => {
  const [isHovering, setIsHovering] = useState(false)

  // Filter campaigns by kind (Sales or Service)
  const filteredCampaigns = campaigns?.filter(c => c.kind === kind) || []

  if (filteredCampaigns.length === 0) {
    return (
      <Cell className={styles.checkCell}>
        <GrayCross />
      </Cell>
    )
  }

  const enabledCount = filteredCampaigns.filter(c => c.isActive).length
  const disabledCount = filteredCampaigns.filter(c => !c.isActive).length
  const totalCount = filteredCampaigns.length

  // Determine overall status
  const allEnabled = enabledCount === totalCount
  const allDisabled = disabledCount === totalCount
  const someDisabled = !allEnabled && !allDisabled

  // Get disabled campaigns with details
  const disabledCampaigns = filteredCampaigns.filter(c => !c.isActive)

  // Build tooltip content
  const getTooltipContent = () => {
    if (allEnabled) {
      return `All ${kind} campaigns enabled`
    }

    let content = `${disabledCount} of ${totalCount} ${kind} campaigns disabled:\n\n`
    disabledCampaigns.forEach(campaign => {
      const category = campaign.category || 'Unknown'
      const reason = campaign.disabledReason || 'No reason provided'
      const updatedOn = campaign.updatedOn
        ? moment(campaign.updatedOn).format('MMM DD, YYYY HH:mm')
        : 'Unknown date'
      const updatedBy = campaign.updatedBy || 'Unknown user'

      content += `${category}:\n`
      content += `Reason: ${reason}\n`
      content += `Updated: ${updatedOn} by ${updatedBy}\n\n`
    })

    return content
  }

  const tooltipId = `campaign-status-tooltip-${kind}-${subsidiaryId}`

  return (
    <Cell className={styles.checkCell}>
      <div
        className={styles.innerWrapper}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        data-tip={!allEnabled ? getTooltipContent() : undefined}
        data-for={!allEnabled ? tooltipId : undefined}
      >
        {allEnabled ? (
          <GreenCheck />
        ) : someDisabled ? (
          <div className={styles.partialStatus}>
            <GreenCheck />
            <span className={styles.partialCount}>{disabledCount}</span>
          </div>
        ) : (
          <GrayCross />
        )}
        {!allEnabled && (
          <ReactTooltip
            id={tooltipId}
            place="top"
            type="dark"
            effect="solid"
            multiline
            className={styles.tooltip}
          />
        )}
      </div>
    </Cell>
  )
}

export default CampaignStatusCell
